import { translate } from '../translate';

import { getCabinClassString } from './getCabinClassString';

export const getDestinationInfoLabel = (destination?: string | null) =>
  destination || translate('searchControls_input_field_destination_placeholder');

export const showDatePlaceHolder = (outboundDate?: string, inboundDate?: string) =>
  !outboundDate && !inboundDate;

export const getDateInfoLabel = (outboundDate?: string, inboundDate?: string) => {
  if (showDatePlaceHolder(outboundDate, inboundDate)) {
    return translate('searchControls_input_field_date_placeholder');
  }
  if (!inboundDate) {
    return outboundDate;
  }
  return `${outboundDate} - ${inboundDate}`;
};

export const getPassengerInfoLabel = (adults: number, childAges: number[], cabinClass?: string) => {
  const travellersCount = adults + childAges.length;
  const baseLabel =
    travellersCount === 1
      ? translate('SearchControls_adult_number', { number: String(travellersCount) })
      : translate('SearchControls_number_of_travellers', { number: String(travellersCount) });

  return cabinClass ? `${baseLabel}, ${getCabinClassString(cabinClass)}` : baseLabel;
};

export const getSearchSummaryAriaLabel = (
  origin: string,
  adults: number,
  childAges: number[],
  destination?: string | null,
  outboundDate?: string,
  inboundDate?: string,
  isMonth?: boolean,
) => {
  const destinationLabel = getDestinationInfoLabel(destination);
  const travellers = getPassengerInfoLabel(adults, childAges);

  if (showDatePlaceHolder(outboundDate, inboundDate)) {
    const placeHolderDateLabel = translate('searchControls_input_field_date_placeholder');
    return translate('aria_search_summary_uncertain_dates', {
      origin,
      destination: destinationLabel,
      uncertainDates: placeHolderDateLabel,
      travellers,
    });
  }

  const isReturnTrip = outboundDate && inboundDate;
  if (isReturnTrip) {
    return isMonth
      ? translate('aria_search_summary_return_trip_whole_month', {
          origin,
          destination: destinationLabel,
          outboundMonth: outboundDate,
          inboundMonth: inboundDate,
          travellers,
        })
      : translate('aria_search_summary_return_trip', {
          origin,
          destination: destinationLabel,
          outboundDate,
          inboundDate,
          travellers,
        });
  }

  return isMonth
    ? translate('aria_search_summary_one_way_whole_month', {
        origin,
        destination: destinationLabel,
        outboundMonth: outboundDate,
        travellers,
      })
    : translate('aria_search_summary_one_way', {
        origin,
        destination: destinationLabel,
        outboundDate,
        travellers,
      });
};
